<template>
  <click-outside :do="close">
    <div class="relative">
      <div @click="toggle">
        <slot name="reference"></slot>
      </div>
      <transition name="fade">
        <div v-if="isVisible && (isMobile || position === 'fixed')" class="backdrop" @click="close"></div>
      </transition>
      <transition name="scale">
        <div
          v-if="isVisible"
          class="bg-white p-5 border-1 border-grey rounded-lg shadow-lg font-normal"
          :class="[
            toolTipClass,
            isMobile ? 'tooltip max-w-xs mx-auto fixed w-full z-50' : ['mx-auto z-50', arrowTo, position]
          ]"
        >
          <span
            v-if="closeVisible"
            @click="close"
            class="absolute top-0 right-0 px-5 py-3 leading-normal text-sm font-helvetica font-light cursor-pointer"
            ><span class="icon-close_icon-1"></span
          ></span>
          <slot></slot>
        </div>
      </transition>
    </div>
  </click-outside>
</template>

<script>
import { preventBodyScroll } from '@/core/helper-functions'
import ClickOutside from '@/components/shared/ClickOutside'
import { useGeneralStore } from '@/stores/general'

export default {
  name: 'TooltipComponent',
  components: { ClickOutside },

  setup () {
    const generalStore = useGeneralStore()

    return {
      generalStore
    }
  },

  props: {
    arrowTo: { type: String, default: '' }, // in which direction is the arrow pointing
    toolTipClass: { type: String, default: '' },
    closeVisible: { type: Boolean, default: true },
    position: { default: 'absolute' }
  },

  data () {
    return {
      isVisible: false
    }
  },

  computed: {
    isMobile () {
      return this.generalStore.isMobile
    }
  },

  methods: {
    toggle () {
      this.isVisible = !this.isVisible
    },
    close () {
      this.isVisible = false
    }
  },

  watch: {
    isVisible (newVal) {
      if (this.isMobile) {
        preventBodyScroll(newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.left,
.right {
  top: 50%;
  transform: translateY(-50%);

  &::after {
    content: ' ';
    position: absolute;
    top: 50%;
    margin-top: -30px;
    border-style: solid;
  }

  &::before {
    content: ' ';
    position: absolute;
    top: 50%;
    margin-top: -31px;
    border-style: solid;
  }
}

.left {
  left: 50px;

  &::after {
    right: 100%;
    border-width: 28px 23px 28px 0;
    border-color: transparent #ffffff transparent transparent;
  }
  &::before {
    right: 100%;
    border-width: 29px 24px 29px 0;
    border-color: transparent #c6c6c6 transparent transparent;
  }
}

.right {
  right: 50px;

  &::after {
    left: 100%;
    border-width: 28px 0 28px 23px;
    border-color: transparent transparent transparent #ffffff;
  }
  &::before {
    left: 100%;
    border-width: 29px 0 29px 24px;
    border-color: transparent transparent transparent #c6c6c6;
  }
}

.bottom,
.top {
  left: 50%;
  transform: translateX(-50%);

  &::after {
    content: ' ';
    position: absolute;
    left: 50%;
    margin-left: -30px;
    border-style: solid;
  }

  &::before {
    content: ' ';
    position: absolute;
    left: 50%;
    margin-left: -31px;
    border-style: solid;
  }
}

.top {
  top: 45px;

  &::after {
    bottom: 100%;
    border-width: 0 30px 15px 30px;
    border-color: transparent transparent #ffffff transparent;
  }
  &::before {
    bottom: 100%;
    border-width: 0 31px 16px 31px;
    border-color: transparent transparent #c6c6c6 transparent;
  }
}

.bottom {
  bottom: 50px;

  &::after {
    top: 100%;
    border-width: 23px 28px 0 28px;
    border-color: #ffffff transparent transparent transparent;
  }
  &::before {
    top: 100%;
    border-width: 24px 29px 0 29px;
    border-color: #c6c6c6 transparent transparent transparent;
  }
}
</style>
